import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const FloatingContact = () => {
  return (
    <div style={styles.container}>
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/917558307059?text=Hello%20I%20need%20assistance"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        style={{ ...styles.button, ...styles.whatsapp }}
      >
        <FaWhatsapp />
      </a>

      {/* Call Button */}
      <a
        href="tel:+917558307059"
        aria-label="Call Now"
        style={{ ...styles.button, ...styles.call }}
      >
        <FaPhoneAlt />
      </a>
    </div>
  );
};

export default FloatingContact;

/* ===========================
   INLINE STYLES (PRODUCTION)
=========================== */
const styles = {
  container: {
    position: "fixed",
    bottom: "90px",
    right: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    zIndex: 9999,
  },
  button: {
    width: "54px",
    height: "54px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#ffffff",
    fontSize: "24px",
    boxShadow: "0 6px 15px rgba(0,0,0,0.3)",
    transition: "transform 0.3s ease",
    textDecoration: "none",
  },
  whatsapp: {
    backgroundColor: "#13697A",
  },
  call: {
    backgroundColor: "#13697A",
  },
};
